// src/pages/MFASetupPage.tsx
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function MFASetupPage() {
  const { getMfaPending, clearMfaPending, confirmRegisterMfa, isLoading } = useAuth();
  const navigate = useNavigate();

  const pending = useMemo(() => getMfaPending(), []);
  const [code, setCode] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (!pending || pending.type !== 'register') navigate('/registro', { replace: true });
  }, [pending, navigate]);

  const canSubmit = code.trim().length >= 6;

  const onCancel = () => {
    clearMfaPending();
    navigate('/registro', { replace: true });
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setTouched(true);
    if (!canSubmit) return;
    await confirmRegisterMfa(code.trim());
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 16, background: '#f7f7fb' }}>
      <div
        style={{
          width: '100%',
          maxWidth: 420,
          background: '#fff',
          border: '1px solid #eee',
          borderRadius: 18,
          padding: 18,
          boxShadow: '0 12px 30px rgba(0,0,0,0.08)'
        }}
      >
        <div style={{ marginBottom: 10 }}>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 900 }}>Verificación por correo</h1>
          <p style={{ margin: '8px 0 0', color: '#666', fontWeight: 600 }}>
            Te enviamos un código a tu correo. Escríbelo para continuar.
          </p>
          {pending?.type === 'register' ? (
            <p style={{ margin: '10px 0 0', color: '#111827', fontWeight: 800, fontSize: 13 }}>{pending.email}</p>
          ) : null}
        </div>

        <form onSubmit={onSubmit} style={{ marginTop: 14, display: 'grid', gap: 12 }}>
          <div>
            <label style={{ display: 'block', fontWeight: 900, marginBottom: 6 }}>Código</label>
            <input
              value={code}
              onChange={e => setCode(e.target.value.replace(/\s/g, ''))}
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="123456"
              style={{
                width: '100%',
                borderRadius: 12,
                border: touched && !canSubmit ? '1px solid #ef4444' : '1px solid #e5e7eb',
                padding: 12,
                outline: 'none',
                fontWeight: 900,
                letterSpacing: 2
              }}
            />
            {touched && !canSubmit ? (
              <div style={{ marginTop: 8, color: '#b91c1c', fontWeight: 800, fontSize: 12 }}>
                Ingresa un código válido (mínimo 6 dígitos).
              </div>
            ) : null}
          </div>

          <button
            type="submit"
            disabled={isLoading || !canSubmit}
            style={{
              border: 'none',
              borderRadius: 12,
              padding: '12px 14px',
              background: '#673ab7',
              color: '#fff',
              fontWeight: 900,
              cursor: 'pointer',
              opacity: isLoading || !canSubmit ? 0.7 : 1
            }}
          >
            {isLoading ? 'Validando...' : 'Continuar'}
          </button>

          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            style={{
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              padding: '12px 14px',
              background: '#fff',
              color: '#111827',
              fontWeight: 900,
              cursor: 'pointer',
              opacity: isLoading ? 0.7 : 1
            }}
          >
            Cancelar
          </button>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 6 }}>
            <Link to="/" style={{ textDecoration: 'none', color: '#673ab7', fontWeight: 900 }}>
              Volver al inicio
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
